import {
  RECOMMENDATIONS_CLEAR,
  RECOMMENDATIONS_UPDATED,
  SET_FREQUENTLY_BOUGHT_TOGETHER,
  CLEAR_FREQUENTLY_BOUGHT_TOGETHER,
  FBT_ITEM_SELECTED,
  FBT_ITEM_UNSELECTED,
  CLEAR_FREQUENTLY_BOUGHT_TOGETHER_SELECTION,
  SHOW_FBT_MODAL,
  HIDE_FBT_MODAL,
  STORE_FBT_COUNT,
} from '../actions/actionTypes';

const initialState = {
  itemId: [],
  suggestedItems: [],
  fbtItems: [],
  selectedFbtItems: [],
  isModalActive: false,
  fbtCartSuccess: false,
  fbtCount: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RECOMMENDATIONS_CLEAR:
      return {
        ...state,
        suggestedItems: [],
      };

    case RECOMMENDATIONS_UPDATED:
      return {
        ...state,
        suggestedItems: action.suggestedItems.schemas[0].products,
      };

    case SET_FREQUENTLY_BOUGHT_TOGETHER:
      return {
        ...state,
        fbtItems: action.fbtItems,
        itemId: action.itemId,
        selectedFbtItems: action.fbtItems.map((fbtItem) => fbtItem.itemId).concat(action.itemId),
      };

    case CLEAR_FREQUENTLY_BOUGHT_TOGETHER:
      return {
        ...state,
        fbtItems: initialState.fbtItems,
      };

    case FBT_ITEM_SELECTED: {
      return {
        ...state,
        selectedFbtItems: [
          ...state.selectedFbtItems.map((selectedFbtItem) => selectedFbtItem),
          action.selectedItem.itemId,
        ],
      };
    }

    case CLEAR_FREQUENTLY_BOUGHT_TOGETHER_SELECTION: {
      return {
        ...state,
        selectedFbtItems: initialState.fbtItems,
      };
    }

    case FBT_ITEM_UNSELECTED: {
      return {
        ...state,
        selectedFbtItems: state.selectedFbtItems.filter(
          (electedFbtItem) => electedFbtItem !== action.selectedItem.itemId
        ),
      };
    }

    case SHOW_FBT_MODAL:
      return {
        ...state,
        isModalActive: true,
        fbtCartSuccess: action.fbtCartSuccess,
      };

    case HIDE_FBT_MODAL:
      return {
        ...state,
        isModalActive: false,
        fbtCount: 0,
      };

    case STORE_FBT_COUNT:
      return {
        ...state,
        fbtCount: action.count,
      };

    default:
      return state;
  }
};
